import { createFileRoute } from "@tanstack/react-router";
import { TaskCalendarView } from "@/views/task-calendar";

function TaskCalendarPage() {
  return <TaskCalendarView />;
}

export const Route = createFileRoute("/_content/tasks/calendar")({
  component: TaskCalendarPage,
});
